<!--  -->
<template>
  <div class="">
    <page-header></page-header>
    <div class="order">
      <order-list></order-list>
    </div>
  </div>
</template>

<script>
import PageHeader from "../components/PageHeader";
import OrderList from "../components/OrderList";

export default {
  components: {
    PageHeader,
    OrderList
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.order {
  width: 1200px;
  margin: 20px auto;
}
</style>
